// extracted by mini-css-extract-plugin
module.exports = {"bgTransparent":"ResetPassword_bgTransparent__332Jz","input":"ResetPassword_input__3sR6y"};